module.exports = __webpack_public_path__ + "static/media/darude-sandstorm.0613e131.mp3";